/*
 * @Author: JamesWong
 * @Description: 3.2小票配置
 * @Date: 2019-01-04 14:59:12
 * @Last Modified by: JamesWong
 * @Last Modified time: 2019-01-07 11:40:21
 */
export default {
  confirm: '确定',
  cancel: '取消',
  channel: '渠道',
  order: '序号',
  edit: '编辑',
  defaults: '默认',
  Operation: '操作',
  templateName: '模板名称',
  enterTemplateName: '请输入模板名称',
  added: '新增',
  review: '预览',
  delete: '删除',
  filters: '渠道性质筛选',
  channelNumber: '渠道编号',
  createDeposit: '定金单',
  salesCreateReciept: '销售做单',
  account: '户口',
  pleaseSelectAgain: '请重新选择',
  channelRecipetConfiguration: '渠道小票配置',
  recipetTemplate: '小票模板',
  depositTemplate: '定金单模板',
  numberTemplate: '张数模板',
  channelType: '渠道性质',
  recipetStyle: '小票样式',
  saleVersion: '做单店铺/顾客联',
  reprintVersion: '重打印店铺/顾客联',
  selectChannelSettings: '选择渠道设置',
  setChannelType: '按渠道性质设置',
  setbyAccount: '按户口设置',
  channelSelected: '已选渠道',
  SaleNum: '店铺/顾客联张数',
  ReprintNum: '重打印-店铺/顾客联张数',
  selectChannel: '请选择渠道',
  saleRecipetNumberTemplate: '销售做单张数模板',
  depositRecipetNumberTemplate: '定金单张数模板',
  reprintNumberTemplate: '重打印张数模板',
  businessType: '业务类型',
  number: '张数',
  selectTips: '请先选择渠道在进行设置小票样式',
  setTips: '设置成功！',
  styleWarn: '请选择 "小票样式" 模板',
  sellWarn: '请选择 "销售做单-店铺/顾客联张数" 模板',
  sellWarn2: '请选择 "定金单-店铺/顾客联张数" 模板',
  reprintWarn: '请选择 "重打印-店铺/顾客联张数" 模板',
  noset: '暂无配置渠道性质',
  select: '已选择',
  numTypeSale: '小票-店铺联/顾客联',
  numTypeReprint: '重打印-店铺联/顾客联',
  deleteReceiptModel: '删除小票模板',
  deleteTips: '确定删除该小票模板？',
  addtips: '添加成功',
  edittips: '修改成功'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/newSlip.js